@if (text()?.length) {
    <span [ngClass]="customClass()">
        @switch (dataType()) {
            @case ("userRoles") {
                <ng-container [ngTemplateOutlet]="userRolesTemplate"></ng-container>
            }
            @default {
                {{ displayed() }}
            }
        }
        {{ !isExpanded() ? "..." : "" }}
    </span>
    @if (needsTruncate()) {
        <button type="button" (click)="toggle()" class="cipo--btn-reset cipo--text--underline m-l-xs cipo-text--primary-500">
            {{ "actions." + (isExpanded() ? "seeLess" : "seeMore") | translate }}
        </button>
    }
} @else {
    <span [ngClass]="customClass()">{{ placeholder() }}</span>
}

<ng-template #userRolesTemplate>
    @for (userRole of userRoles(); track $index) {
        @let title =
            `${userRole.user}${userRole.roleAbbrs?.length ? " (" + userRole.roleAbbrs.join(separator()) + ")" : ""}`;
        <span [title]="title">{{ userRole.user }}{{ $index < userRoles().length - 1 ? separator() : "" }}</span>
    }
</ng-template>
